import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default class ContentBannerIcon extends Component {
  render() {
    const icon = SelectionFactoryHelper.getFromSelectionFactory(this.props.icon)
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.backgroundColor)
    const buttonModifier = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonModifiers)
    const buttonStyle = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonStyle)
    return (
      <div className="deck deck--no-image deck--terms-and-icon">
        <div className={`content-banner content-banner--full ${backgroundColor && backgroundColor}`} style={{ clear: "both" }}>
          <div className={`content-banner__content ${backgroundColor && backgroundColor}`}>
            <div className="inner">
              <div className="icon">
                <Svg iconName={icon} />
              </div>
              <h2>
                <span dangerouslySetInnerHTML={{ __html: this.props.headline }}></span>
              </h2>
              <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.text }}></span>
              <a
                href={this.props.buttonLink}
                className={`button button--${buttonStyle && buttonStyle} no-shadow ${buttonModifier && buttonModifier}`}
              >
                <span className="text">{this.props.buttonText}</span>
              </a>
            </div>
            <div className="terms-text">{this.props.termsText}</div>
          </div>
        </div>
      </div>
    )
  }
}
